module.exports = __webpack_public_path__ + "static/projects-yardly-view-83eddaf26bd803a5ababd8408fd462ac.jpg";